// src/components/UserListTable.js
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button
} from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { useNavigate } from 'react-router-dom';

export default function UserListTable({ users }) {
  const navigate = useNavigate();

  const handleViewUser = (userId) => {
    navigate(`/users/${userId}`);
  };

  // FILTRO DI SICUREZZA:
  // Escludiamo a priori i record "fantasma" che non hanno né nome né email.
  // In questo modo la tabella rimarrà sempre pulita ed eviteremo crash in UI.
  const validUsers = users.filter(user => {
    const hasName = user.fullName && typeof user.fullName === 'string' && user.fullName.trim() !== "";
    const hasEmail = user.email && typeof user.email === 'string' && user.email.trim() !== "";
    return hasName || hasEmail;
  });

  return (
    <TableContainer component={Paper} elevation={0}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Nome e Cognome</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Telefono</TableCell>
            <TableCell sx={{ width: '100px', textAlign: 'center' }}>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {validUsers.map((user) => (
            <TableRow key={user.id}>
              <TableCell>{user.fullName || '---'}</TableCell>
              <TableCell>{user.email || '---'}</TableCell>
              <TableCell>{user.phone || '---'}</TableCell>
              
              <TableCell sx={{ textAlign: 'center' }}>
                <Button 
                  variant="contained" 
                  size="small"
                  startIcon={<LaunchIcon />}
                  onClick={() => handleViewUser(user.id)}
                  sx={{ 
                    backgroundColor: '#E7A4C7', 
                    color: '#212121', 
                    '&:hover': {
                      backgroundColor: '#d68bb9',
                    }
                  }}
                >
                  Entra
                </Button>
              </TableCell>
            </TableRow>
          ))}
          
          {/* Mostriamo il messaggio vuoto basandoci sull'array filtrato */}
          {validUsers.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} sx={{ textAlign: 'center', py: 3 }}>
                Nessun utente trovato con i criteri di ricerca.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}